import * as MyKeysApi from './index';
import * as Customers from '../../../modules/customers';
import { buildCriteraList } from './searchCriteria';
import { GroupCriteriaDto } from '../../../models';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

export const searchPage = (
  pageIdx: number,
  customersState: Customers.State
): Promise<any> => {
  const requestBatch = customersState.data.pageSize;

  const criteria = buildCriteraList(
    customersState.filters,
    customersState.sort
  );
  const body = {
    groupCriteria: GroupCriteriaDto.Customer,
    criteria,
    pageIndex: pageIdx - 1,
    pageSize: requestBatch,
  };

  Logger.info(
    ['POST: Customer Search Requested', customersState, body],
    LogArea.Api
  );
  return MyKeysApi.post('devices/GetGroupList', body, true)
    .then((res) => MyKeysApi.Map.mapCustomerGroupListDto(res.data))
    .catch(MyKeysApi.parseError);
};

export default searchPage;
